import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";

import { ProcessDataForExpress } from "../../../CommonFunction/ProcessDataForExpress";
import getExpressHeaders from "../../../CommonFunction/getExpressHeaders";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import useLazyFetch from "../EmtAccounts/UseLazyFetch";
import { AddSalesExpFormula, AddSalesInvoceType } from "../../Components/FormComponents";
import SalseInvoiceType from "../SalesBillSetup/TaxGroup/TaxGroup";
import SalesExpenseFormula from "../SalesBillSetup/Tax/Tax";

const Taxes = () => {
    const [selectedCate, setSelectedCate] = useState<any>({
        Profile_Type: "Company_Logistics",
    });
    const [tableKey, setTableKey] = useState("");
    let Refetch = useSelector((store: any) => store?.FormFieldData.refresh);
    const Tab = useSelector((store: any) => store.SelectedTabData);
    const { pushKey, popKey } = useModalContext();
    const [Key, setKey] = useState("EMT_Logistics");
    const dispatch = useDispatch();
    let statusTab = [
        { name: "Tax Group", CompName: SalseInvoiceType },
        // { name: "Transporter" },
        { name: "Tax", CompName: SalesExpenseFormula },

    ];

    useEffect(() => {
        dispatch({ type: "TabData", payload: { tab: "Tax Group", TabObj: { name: "Tax Group", CompName: SalseInvoiceType } } });
    }, [])

    console.log(Tab)
    const getComp = () => {
        console.log(Tab)
        let Comp = Tab?.TabObj?.CompName
        if (Comp)
            return <Comp />
    }
    return (
        <div className="LoadContainer">
            {/* <div className="HeaderDiv">
                <div>
                    <p className="pageTitle">Tax</p>
                    <div className="hr1ForPageTitle"></div>
                </div>
                <SearchBoxesDiv />
            </div> */}
            <Tabs tabs={statusTab} />
            {getComp()}

        </div>
    );
};

export default Taxes;
